export const eventTypeMapper: { [key: string]: string } = {
    opera: "Opera",
    esports: "Esports",
    sports: "Sports",
  };